// extracted by mini-css-extract-plugin
export var body = "_fw-8";
export var button = "_fw-0";
export var closeButton = "_fw-5";
export var content = "_fw-3";
export var empty = "_fw-f";
export var grid = "_fw-c";
export var header = "_fw-4";
export var icon = "_fw-1";
export var option = "_fw-d";
export var optionSelected = "_fw-e";
export var overlay = "_fw-2";
export var searchIcon = "_fw-a";
export var searchInput = "_fw-b";
export var searchWrapper = "_fw-9";
export var title = "_fw-6";
export var visuallyHidden = "_fw-7";